// What to keep from the pinned records once the server has answered (C315, X7-11b). Pure: no storage, no network.
import { isRecordRef, type RecordRef } from "@/features/search/recordIndex";

export const FAVOURITES_LIMIT = 40;

/** A path inside the app: starts with "/" and not "//". The server value is never trusted for href. */
const safe = (r: RecordRef) => r.href.startsWith("/") && !r.href.startsWith("//");

/** What to keep once the server has answered. `server` is the saved value, or undefined when nothing was ever saved.
 *  A saved list (even an empty one) wins, so an unpin on another device sticks; with nothing saved, this browser's pins are kept and pushed up.
 *  Entries whose href is not a path inside the app (must start with "/" and not "//") are dropped. */
export function reconcileFavourites(server: unknown, local: RecordRef[]): { list: RecordRef[]; push: boolean } {
  if (Array.isArray(server)) {
    return { list: server.filter(isRecordRef).filter(safe).slice(0, FAVOURITES_LIMIT), push: false };
  }
  const list = local.filter(safe).slice(0, FAVOURITES_LIMIT);
  return { list, push: list.length > 0 };
}
